import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Application, Job, Student } from '../../../models/college-dashboard.model';
import { CollegeDashboardService } from '../../../services/college-dashboard.service';

@Component({
  selector: 'app-attention-detail-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './attention-detail-modal.component.html',
  styleUrl: './attention-detail-modal.component.scss'
})
export class AttentionDetailModalComponent implements OnInit {
  @Input() initialCategory: 'Profiles Incomplete' | 'Offers Awaiting Response' | 'New Companies This Week' = 'Profiles Incomplete';
  @Output() close = new EventEmitter<void>();
  @Output() selectStudent = new EventEmitter<Student>();
  @Output() selectJob = new EventEmitter<string>();

  activeCategory: 'Profiles Incomplete' | 'Offers Awaiting Response' | 'New Companies This Week' = 'Profiles Incomplete';

  constructor(private dashboardService: CollegeDashboardService) {}

  ngOnInit(): void {
    if (this.initialCategory) {
      this.activeCategory = this.initialCategory;
    }
  }

  get incompleteProfiles(): Student[] {
    return this.dashboardService.getIncompleteProfiles();
  }

  get pendingOffers(): { student: Student | undefined; job: Job | undefined; app: Application }[] {
    return this.dashboardService.getPendingOffers();
  }

  get newCompanies(): Job[] {
    return this.dashboardService.getNewCompaniesThisWeek();
  }

  get modalTitle(): string {
    switch (this.activeCategory) {
      case 'Profiles Incomplete':
        return 'Incomplete Profiles';
      case 'Offers Awaiting Response':
        return 'Offers Awaiting Response';
      case 'New Companies This Week':
        return 'New Companies This Week';
    }
  }

  onStudentClick(student: Student): void {
    this.selectStudent.emit(student);
    this.close.emit();
  }

  onJobClick(job: Job): void {
    this.selectJob.emit(job.id);
    this.close.emit();
  }
}
